import type VueI18n from 'vue-i18n'
import type {
    AxiosInstance,
    AxiosPromise,
    AxiosRequestConfig
} from 'axios'
import type { RequestConfig } from '@patsnap/common-ps-http';
import { CaseTimeAxiosError } from '../utils/errors'
import { getTimezoneId } from '../utils/time'
interface IHttpConfig {
    i18n: VueI18n
    transferGetter: () => AxiosInstance
}
export class Http {
    constructor(private config: IHttpConfig) {
    }
    request<T = any>(config: RequestConfig | AxiosRequestConfig): AxiosPromise<T> {
        const transfer = this.config.transferGetter()
        if (!config.params) {
            config.params = {}
        }
        config.params.timezoneid = getTimezoneId()
        if (!config.headers) {
            config.headers = {}
        }
        config.headers['X-Requested-With'] = 'XMLHttpRequest'
        return transfer.request(config).then(
            data => data,
            // wrapper spec error
            err => {
                throw new CaseTimeAxiosError(this.config.i18n, err)
            }
        )
    }
}
